import ApprovePaymentDialog from './ApprovePaymentDialog'

export default ApprovePaymentDialog
